angular.module('picmonicng').directive('everythingBlock', [
  function () {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/everything-block.html',
      controller: [
        '$scope',
        '$rootScope',
        'BrowseService',
        'User',
        function ($scope, $rootScope, BrowseService, User) {
          $scope.everything_loading = true;
          $scope.base_asset_url = $rootScope.base_asset_url;
          $scope.stats = User.getv3({ resource: 'stats' });
          $scope.stats.$promise.then(function () {
            $scope.everything_loading = false;
          });

          $scope.select = function (option) {
            var params = { q: '' };
            switch (option) {
              case 0:
                params.onlyPicmonics = true;
                break;
              case 1:
                params.onlyPathways = true;
                break;
              case 2:
                params.onlyPicmonics = false;
                params.onlyPathways = false;
                break;
              case 3:
                params.sort_by = { value: 'newest' };
                params.onlyPicmonics = true;
            }
            BrowseService.go('app.search', params, { force: true });
          };
        },
      ],
    };
  },
]);
